<template>
  <div style="width: 100%; height: 100%;">
    <span>sda</span>
    <error-content backBtn="true" code="500" :desc="langMap.serverError[lang]" :src="src"/>
    <Modal
      v-model="showLoginModal"
      :title="langMap.sessionExpired[lang] || '会话已过期'"
      :closable="false"
      :mask-closable="false"
    >
      <p>{{ langMap.sessionExpiredMessage[lang] || '您的登录信息已过期，请重新登录。' }}</p>
      <div slot="footer">
        <Button @click="goToLogin" type="primary">{{ langMap.reLogin[lang] || '重新登录' }}</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import error404 from '@/assets/images/error-page/error-500.svg'
import errorContent from './error-content.vue'
import langMap from '@/utils/language';
import { mapState } from 'vuex';
import { clearLocalCache } from '@/libs/util'

export default {
  name: 'error_500',
  components: {
    errorContent
  },
  data () {
    return {
      langMap: langMap,
      src: error404,
      showLoginModal: true
    }
  },
  computed: {
    ...mapState({
      lang: state => state.app.language,
    }),
  },
  created() {
    console.log(4+this.lang)
  },
  methods: {
    // 清空所有存储
    clearAllStorage() {
      try {
        // 清空 Cookie
        const cookies = document.cookie.split(";");
        for (let i = 0; i < cookies.length; i++) {
          const cookie = cookies[i];
          const eqPos = cookie.indexOf("=");
          const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
          document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
        }

        // 清空 localStorage
        clearLocalCache();

        // 清空 sessionStorage
        sessionStorage.clear();

        console.log('所有存储已清空');
      } catch (error) {
        console.error('清空存储时出错:', error);
      }
    },

    // 跳转到登录页
    goToLogin() {
      // 关闭弹窗
      this.showLoginModal = false;
      // 清空所有存储
      this.clearAllStorage();
      // 跳转到登录页
      const loginPath = '/login';
      if (this.$router) {
        this.$router.push(loginPath);
      } else {
        window.location.href = loginPath;
      }
    }
  }
}
</script>

<style scoped>
/* 可以添加一些自定义样式 */
</style>
